import InputWrapper from "../../../../../../components/input/wrapper/InputWrapper";
import Select from "../../../../../../components/select/main/Select";
import { useLanguageContext } from "../../../../../../context/LanguageContext";
import EVAApiHelper from "../../../../../../helpers/EVAApiHelper";
import { StyledFlexColumn } from "../../../../../../styles/LayoutStyles";
import FontForm from "../default/font/FontForm";
import PositionForm from "../default/position/PositionForm";
import SizeForm from "../default/size/SizeForm";

function FieldFormView({
  setPrinterData,
  selectedLabelItem,
  selectedLabelItemIndex,
  submitError,
  fields,
  onFieldChange,
}) {
  const { translate, translateEntity } = useLanguageContext();

  return (
    <StyledFlexColumn>
      {/* Position */}
      <PositionForm
        setPrinterData={setPrinterData}
        selectedLabelItem={selectedLabelItem}
        selectedLabelItemIndex={selectedLabelItemIndex}
        submitError={submitError}
      />

      {/* Size */}
      <SizeForm
        setPrinterData={setPrinterData}
        selectedLabelItem={selectedLabelItem}
        selectedLabelItemIndex={selectedLabelItemIndex}
        submitError={submitError}
      />

      {/* Font */}
      <FontForm
        setPrinterData={setPrinterData}
        selectedLabelItem={selectedLabelItem}
        selectedLabelItemIndex={selectedLabelItemIndex}
        submitError={submitError}
      />

      <InputWrapper
        label={translate(
          "eva.main.validation.attributes.label_items.*.field_id"
        )}
        required
        error={EVAApiHelper.getResponseError(
          `label_items.${selectedLabelItemIndex}.field_id`,
          submitError
        )}
      >
        <Select
          options={fields.map((field) => ({
            value: field.id,
            label: translateEntity(field, "label"),
          }))}
          value={selectedLabelItem.field_id}
          onChange={onFieldChange}
        />
      </InputWrapper>
    </StyledFlexColumn>
  );
}

export default FieldFormView;
